module.exports = __webpack_public_path__ + "static/media/Flagpole.70c6ecce.svg";